<template>            
    <div class="hero-info">      
      <div>
        <span class="big">Hero</span> {{ hero.name }}   {{ getTraitGlyph(hero.trait) }} {{ getStarsGlyph(hero.stars) }}
      </div>
        <ul>
            <li v-if="hero.hpBonus > 0" ><span>hp:</span>+{{ Math.round(hero.hpBonus * 100) }}%</li>
            <li v-if="hero.attackBonus > 0" ><span>attack:</span>+{{ Math.round(hero.attackBonus * 100) }}%</li>
            <li v-if="hero.armorBonus > 0" ><span>armor:</span>+{{ Math.round(hero.armorBonus * 100) }}%</li>
            <li v-if="hero.defenseBonus > 0"><span>defense:</span>+{{ Math.round(hero.defenseBonus * 100) }}%</li>
            <li v-if="hero.traitBonus > 0"><span>trait:</span>+{{ Math.round(hero.traitBonus * 100) }}% to all {{getTraitGlyph(hero.trait)}} stats</li>
        </ul>
    </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { IHeroReport } from "../../game/shared/IBattleReport.ts";
import { getStarsGlyph, getTraitGlyph } from "../../game/Helpers.ts";
import { TroopTrait } from "../../game/shared/JsonDefinitions.ts";
export default defineComponent({
props: {
    hero: {
        type: Object as PropType<IHeroReport>,
        required: true,
    },
},
methods: {
    getStarsGlyph,
    getTraitGlyph,
    geTraitBonusTarget(trait: TroopTrait) {
      switch (trait) {
            case TroopTrait.Footman:
                return TroopTrait.Mounted ;
            case TroopTrait.Mounted:
                return TroopTrait.Ranged;
            case TroopTrait.Ranged:
                return TroopTrait.Footman;           
        }
    },
},
});
</script>

<style scoped>
.hero-info {
    margin-bottom: 5px;
    
}

.big {
    display: inline-block;
    font-size: 1.1em;
    font-weight: bold;
    margin: 15px 0 0;
}

ul {
    margin: 0;
    padding: 10px 0 0 20px;
}

li span {
        display: inline-block;
        width: 130px;
}
</style>
